import { Injectable } from "@angular/core";
import { drctJsFunctions, DRCTMessage } from "@drct-web-apps/ui-types";
import { filter, Observable, Subject } from "rxjs";
import { UiServicesLogger } from "./ui-services.logger.service";


@Injectable({
  providedIn: 'root'
})
export class UiServicesMessage {
    private _msgChannel!: BroadcastChannel;
    private _channelName!: string;

    get channelName(): string {
        return this._channelName;
    }

    private _msgBroker!: Subject<DRCTMessage>;

    constructor(private readonly logger: UiServicesLogger) { }

    public initBroadcastChannel(): void {
        this._channelName = crypto.randomUUID().toString().toUpperCase();
        this._msgChannel = new BroadcastChannel(this._channelName);
        drctJsFunctions.initBroadcastChannel(this._channelName);

        this._msgBroker = new Subject<DRCTMessage>();

        this.logger.log("Broadcast Channel Initialized: " + this._channelName);
        this._msgChannel.addEventListener("message", (event) => {
            this._msgBroker.next(event.data)
        });
    }

    public onMessage(msgType: string): Observable<DRCTMessage> {
        return this._msgBroker
                   .pipe(filter((msg: DRCTMessage) => msg.type === msgType));
    }

    public closeBroadcastChannel(): void  {
        if(this._msgChannel)
            this._msgChannel.close();
        if(this._msgBroker)
            this._msgBroker.unsubscribe();

        this._channelName = '';
    }
}